export default {"src":"/_next/static/media/Frosinone.8e5b96d3.svg","height":250,"width":220,"blurWidth":0,"blurHeight":0};